import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "py-3" }
const _hoisted_2 = { class: "px-6 py-3" }
const _hoisted_3 = { class: "space-y-6" }
const _hoisted_4 = { class: "" }
const _hoisted_5 = { class: "w-8/12 px-6 py-5 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_6 = { class: "px-6 py-5 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_7 = { class: "px-6 py-5 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_8 = { class: "px-6 py-5 text-sm text-gray-900 whitespace-nowrap" }

import AdminLayout from '@/layouts/AdminLayout.vue';
import FilterComponent from '@/components/FilterComponent.vue';
import DataTable from '@/components/DataTable.vue';
import TabComponent from '@/components/TabComponent.vue';
import ButtonComponent from '@/components/ButtonComponent.vue';
import PageLoader from "@/components/PageLoader.vue";
import ErrorModal from '@/components/ErrorModal.vue';
import PagePagination from '@/components/PagePagination.vue';
import DatePicker from '@/components/inputs/DatePicker.vue';
import SuccessModal from '@/components/modal/SuccessModal.vue';
import { ref, onMounted, watch } from 'vue';
import { paginatePage } from '@/helpers/PageHelper';
import ReportService from '@/classes/ReportService';
import { startOfYear, endOfYear } from 'date-fns';
import MultiselectInput from '@/components/inputs/MultiselectInput.vue';
import { format } from 'date-fns';
import { formatDate } from '@/helpers/TimeFormatter'
import throttle from "lodash/throttle";

interface activeMember {
    Full_Name: string,
    Hospital_Number: string,
    Last_Login_At: Date,
}

interface Item {
    data: activeMember[]
    total: number
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ActiveMember',
  setup(__props) {

const loader      = ref(false);
const showSuccess = ref(false);
const showError   = ref(false);
const errorMsg    = ref();
const goToPage    = ref();
const patientType = ref(null);
const searchText = ref();

const items = ref<Item>({
    data: [],
    total: 0
});
const dateRange = ref([
    startOfYear(new Date).toISOString(),
    endOfYear(new Date).toISOString(),
]);

const headers: { text: string }[] = [
    { text: 'Patient Name' },
    { text: 'Type' },
    { text: 'Patient ID' },
    { text: 'Date Created' },
];

const applyFilters = () => {
    fetchActiveMembers(goToPage.value);
}

const searchData = (val: string) => {
    searchText.value = val
}

const fetchActiveMembers = async (data: string) => {
    try {
        loader.value = true;

        const startDate = dateRange.value ? `&startDate=${dateRange.value[0]}` : '';
        const endDate   = dateRange.value ? `&endDate=${dateRange.value[1]}` : '';
        const patientTypeQuery = patientType.value ? `&patientType=${patientType.value}` : '';
        const queryString = searchText.value ? `&search_key=${searchText.value}` : '';
        
        goToPage.value = paginatePage(data)

        const response   = await ReportService.fetchActiveMembers(`${goToPage.value}${startDate}${endDate}${patientTypeQuery}${queryString}`);
        loader.value = false;
        
        items.value = response.data;
    } catch (error: any) {
            loader.value    = false;
            showError.value = true;
            errorMsg.value  = error;

            if(error.response.status == 401) {
                window.location.replace('/login');
            }
    }
    finally{
        loader.value = false
    }
}

const exportActiveMembers = async () => {
    try {
        loader.value = true;
        const startDate = dateRange.value ? `startDate=${dateRange.value[0]}` : '';
        const endDate   = dateRange.value ? `&endDate=${dateRange.value[1]}` : '';
        const patientTypeQuery = patientType.value ? `&patientType=${patientType.value}` : '';
        const queryString = searchText.value ? `&search_key=${searchText.value}` : '';

        await ReportService.exportActiveMembers(`${startDate}${endDate}${patientTypeQuery}${queryString}`);

        showSuccess.value = true;
    } catch (error: any) {
        showError.value = true;
        errorMsg.value  = error.response?.data.message;
    } finally {
        loader.value = false;
    }
};

const patientTypes = [
    { id: '1', label: 'All', value: 'All' },
    { id: '2', label: 'Individual', value: 'Individual' },
    { id: '3', label: 'Corporate', value: 'Corporate' },
    { id: '4', label: 'Dependent', value: 'Dependent' },
];

/**
 * ********************************
 * Wathchers 
 * ********************************
 */
watch(
    searchText,
    throttle(() => {
        fetchActiveMembers(goToPage.value)
    }, 1000)
);

onMounted(() => { fetchActiveMembers(goToPage.value); })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AdminLayout, {
    title: "Number of Active Members",
    "show-back": "",
    backUrl: "/reports"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(TabComponent, { "button-items": true }, {
          buttons: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(ButtonComponent, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (exportActiveMembers())),
                class: "text-gray-900",
                secondary: "",
                exportBtn: ""
              }, {
                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                  _createTextVNode(" Export ", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(FilterComponent, {
          "text-filters": false,
          "onUpdate:filters": applyFilters,
          textFilters: "",
          search: searchText.value,
          onFetchData: searchData
        }, {
          fields: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(DatePicker, {
                id: "dateRange",
                name: "dateRange",
                range: "",
                is24: "",
                isPresetRanges: "",
                modelValue: dateRange.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dateRange).value = $event)),
                placeholder: "Start Date & End Date",
                label: "Start Date & End Date"
              }, null, 8, ["modelValue"]),
              _createVNode(MultiselectInput, {
                modelValue: patientType.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((patientType).value = $event)),
                id: "patientType",
                name: "patientType",
                label: "Patient Type",
                placeholder: "Patient Type",
                options: patientTypes
              }, null, 8, ["modelValue"])
            ])
          ]),
          _: 1
        }, 8, ["search"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(DataTable, {
          headers: headers,
          noAction: true,
          count: items.value?.total
        }, {
          body: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value?.data, (activeMember, key) => {
              return (_openBlock(), _createElementBlock("tr", { key: key }, [
                _createElementVNode("td", _hoisted_5, _toDisplayString(activeMember.first_name + ' ' + activeMember.last_name), 1),
                _createElementVNode("td", _hoisted_6, _toDisplayString(activeMember.patient_type ?? '--'), 1),
                _createElementVNode("td", _hoisted_7, _toDisplayString(activeMember.patient_id ?? '--'), 1),
                _createElementVNode("td", _hoisted_8, _toDisplayString(`${_unref(formatDate)(activeMember.created_date)}`), 1)
              ]))
            }), 128))
          ]),
          _: 1
        }, 8, ["count"]),
        _createVNode(PagePagination, {
          class: "mb-6",
          items: items.value,
          onNextPage: fetchActiveMembers
        }, null, 8, ["items"])
      ]),
      (loader.value)
        ? (_openBlock(), _createBlock(PageLoader, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(SuccessModal, {
        show: showSuccess.value,
        onCancel: _cache[3] || (_cache[3] = ($event: any) => (showSuccess.value = false)),
        onConfirm: _cache[4] || (_cache[4] = ($event: any) => (showSuccess.value = false)),
        "action-text": "Close",
        title: "Active Members Export",
        content: "Export is being processed. Please check your registered email."
      }, null, 8, ["show"]),
      _createVNode(ErrorModal, {
        width: "w-[548px]",
        title: "Error",
        "action-text": "Close",
        "cancel-text": "Go back",
        show: showError.value,
        onClose: _cache[5] || (_cache[5] = ($event: any) => (showError.value = false)),
        onConfirm: _cache[6] || (_cache[6] = ($event: any) => (showError.value = false))
      }, {
        content: _withCtx(() => [
          _createTextVNode(_toDisplayString(errorMsg.value), 1)
        ]),
        _: 1
      }, 8, ["show"])
    ]),
    _: 1
  }))
}
}

})